import { render, staticRenderFns } from "./ObjectRefsDialog.vue?vue&type=template&id=71a5f128"
import script from "./ObjectRefsDialog.vue?vue&type=script&lang=js"
export * from "./ObjectRefsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports